// extracted by mini-css-extract-plugin
module.exports = {"container":"e_gS","commentPolicy":"e_hS"};